<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="list-dialog"
             center
             :close-on-click-modal="false" :show-close="true"
             :append-to-body="true"
             :modal="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="12">
          <!--<el-select class="Select" v-model="cangkucode" placeholder="请选择仓库" style="width:130px">-->
            <!--<el-option v-for="item in jxcstoreData" :key="item.cangkucode"-->
                       <!--:label="item.cangkuname"-->
                       <!--:value="item.cangkucode">-->
            <!--</el-option>-->
          <!--</el-select>-->
          <!--<CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindTree" :isShowCheckBox="false"-->
                      <!--:treeHeight="400" :treeWidth="400" :searchText="seedname" :canDelete="false"-->
                      <!--style="width:200px;display: inline-block;" @check="checktree"></CommonTree>-->
          <el-date-picker
            v-model="plmonthrange"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
        </el-col>
        <el-button type="primary"  @click="jisuanstock">计算</el-button>
        <el-button  @click="exportExceltable">导出</el-button>
      </el-col>
    </div>
    <el-col :span="24">
      <el-col :span="21">
        <div v-if="showerweitable&&filltemplate!=40" ref="print1">
          <TwoDimensionalTable ref="referweibiao" :isShowTotalNumber="true" :erweitable="erweitable" @num="totalnumber"></TwoDimensionalTable>
        </div>
        <!--<div v-if="showzuoyoutable&&filltemplate!=40" ref="print1">-->
          <!--<el-col :span="2" style="text-align: left">右眼：</el-col>-->
          <!--<el-col :span="6">-->
            <!--<TwoDimensionalTable ref="referweibiaoright" :isShowTotalNumber="true" :erweitable="erweitableright" :cutHeight="100" @num="totalnumber"></TwoDimensionalTable>-->
          <!--</el-col>-->
          <!--<el-col :span="2" style="text-align: left">左眼：</el-col>-->
          <!--<el-col :span="6">-->
            <!--<TwoDimensionalTable ref="referweibiaoleft" :isShowTotalNumber="true" :erweitable="erweitableleft" :cutHeight="100" @num="totalnumber"></TwoDimensionalTable>-->
          <!--</el-col>-->
        <!--</div>-->
      </el-col>
    </el-col>
  </el-dialog>
</template>

<script>
  import {  goodssalenum} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getPrice} from '@/api/set/goodsprice';
  import {saveData} from '@/api/set/jxcstorelimit';

  export default {
    name: "zhinengstock",
    data() {
      return {
        costpricebook: {},
        title: '滞销光度',
        dialogFormVisible: false,
        monthvalue:[],
        plmonthrange:[],
        initContent: [],
        initContentLeft: [],
        initContentRight: [],
        erweitable: [],//二维表
        erweitableleft: [],
        erweitableright: [],
        seedcode: '',//商品编码
        seedname: '',
        cangkucode: '',//仓库编码
        filltemplate: '',//
        jxcstoreData: [],//仓库
        tableData: [],
        tableData2: [],
        tableStoreDetail: [],
        showzuoyoutable: false,
        showerweitable: false,
        erpserials: "",//销售单明细
        monthflag: [],//月份
        number: 0,
        form: {  //表单数据
          seedcode: "",
          minstorebook: "",
          maxstorebook: "",
          cangkucode: "",
          enabled: 1,
          filltemplate: ""
        },
      }
    },
    methods: {
      totalnumber(num) {
        this.number = num
      },
      //计算库存
      jisuanstock() {
        if (this.plmonthrange.length == 0) {
          this.$message.error("请先选择月份");
          return
        }
        var bgdate = new Date(this.plmonthrange[0]);
        var eddate = new Date(this.plmonthrange[1]);

        goodssalenum({
          begindate: bgdate.getFullYear() + "-" + (bgdate.getMonth() + 1) + "-1",
          enddate: eddate.getFullYear() + "-" + (eddate.getMonth() + 1) + "-1",
          seedcode: this.seedcode,
          cangkucode: this.cangkucode
        }).then(response => {
          //返回光度的销售量
          var lowContent = [];
          for (let i in this.initContent) {
            var kuRow = this.initContent[i];
            if (!kuRow.P || !(parseInt(kuRow.P) > 0)) continue;

            var hasValue = false;
            for (let j in response.data.obj) {
              var row = response.data.obj[j];
              var pg = JSON.parse(row.packagesize);
              if (parseFloat(pg.X) == parseFloat(kuRow.X) && parseFloat(pg.Y) == parseFloat(kuRow.Y)) {
                hasValue = true;
                break;
              }
            }
            if (!hasValue) {//没有销量的库存
              lowContent.push(kuRow);
            }
          }
          this.$nextTick(() => {
            this.createPriceBook(lowContent)
          })
        })
      },
      exportExceltable() {
        // var ckname = '';
        // for (let i in this.jxcstoreData) {
        //   if (this.jxcstoreData[i].cangkucode == this.cangkucode) {
        //     ckname = this.jxcstoreData[i].cangkuname;
        //     break;
        //   }
        // }
        this.$refs.referweibiao.getExcel( this.seedname);
      },
      show(obj) {
        this.init()
        this.filltemplate = obj.filltemplate
        this.seedcode = obj.seedcode
        this.seedname = obj.seedname
        this.cangkucode = obj.cangkucode
        this.initContent=obj.initContent
        this.dialogFormVisible = true;
        this.controlerweitableview()
        //判断是否有成本价
        this.getXYRange()
      },
      //初始化
      init() {
        //年份
        this.minyear = new Date()
        this.xishu = ''
        this.seedname = ''
        this.seedcode = ''
        this.monthvalue=[]
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        this.filltemplate = ''
        this.tableData = []
        this.tableData2 = []
        this.tableStoreDetail = []
        this.monthflag = []
        for (let i in this.form) {
          if (i == 'enabled') {
            this.form[i] = 1
          } else
            this.form[i] = ''
        }
      },
      bindTree() {//绑定树控件
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1})
        })
      },
      checktree(guids, names, arr) {
        this.seedcode = guids
        this.seedname = names
        this.showzuoyoutable = false
        this.showerweitable = false
        this.filltemplate = arr[0].attributes.filltemplate
        this.controlerweitableview()
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.form.seedname == "") {
          return
        }
        //判断是否有成本价
        this.getXYRange()
      },
      getXYRange() {
        getPrice({seedcode: this.seedcode, filterType: "cost", notneedconnectprice: true}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }

          if (this.filltemplate == 30) {
            this.createPriceBookzy();
          } else {
            this.createPriceBook([])
          }

        })

      },
      controlerweitableview() {//控制左右眼二维表
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
        } else {
          this.showzuoyoutable = false
          this.showerweitable = true
        }

      },
      createPriceBook(content) {
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initBook(this.costpricebook, content, "")
        }
      },
      createPriceBookzy(defaultprice) {//区分左右眼的二维表
        if (this.$refs.referweibiaoleft)
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.initContentLeft, defaultprice || "")
        if (this.$refs.referweibiaoright)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.initContentRight, defaultprice || "")
      },
      gongyong(title) {
        var arr = [];
        var arrleft = [];
        var arrrigth = [];
        if (this.filltemplate == "30") {
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {

              return typeof(t.P) != "undefined" && t.P !== ""
            })
            arrleft = arrleft.concat(temp)
          }
          arrleft = this.getFormat(arrleft)
          for (let i in  arrleft) {
            arrleft[i]["type"] = "L"
          }

          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== ""
            })
            arrrigth = arrrigth.concat(temp)
          }

          arrrigth = this.getFormat(arrrigth)

          for (let i in  arrrigth) {
            arrrigth[i]["type"] = "R"
          }
          arr = arrrigth.concat(arrleft)

        } else {
          for (let i in   this.erweitable) {
            let temp = this.erweitable[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== ""
            })
            arr = arr.concat(temp)
          }
          arr = this.getFormat(arr)//未填写的数量赋0
        }
        if (title == "最小库存") {
          this.form.maxstorebook = null;
          this.form.minstorebook = JSON.stringify(arr);
        } else {
          this.form.minstorebook = null;
          this.form.maxstorebook = JSON.stringify(arr);
        }
      },
      getFormat(data) {//未填写的数量赋0
        var table = []
        this.costpricebook.BookContent.forEach(o => {
          let temp = data.filter(item => {
            return item.X == o.X && item.Y == o.Y
          })
          if (temp.length > 0) {
            o.P = temp[0].P
          }
          else {
            o.P = 0
          }
          table.push(Object.assign({}, o))
        })
        return table
      },
    },
    mounted() {
      //仓库
      cusandptbyind({}).then(response => {
        this.jxcstoreData = response.data.obj
      })

    },
    components: {
      TwoDimensionalTable
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/zhinengstock.vue